"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TYPES = exports.Permissions = exports.ENDPOINTS = exports.QUEUES = exports.EVENTS = exports.COLLECTIONS = exports.ERRORS = exports.SEARCH_INDICES = exports.CONSTANTS = exports.TASKS_ID = exports.REST_ID = exports.SERVICE_NAME = void 0;
exports.SERVICE_NAME = 'user';
exports.REST_ID = `${exports.SERVICE_NAME}-rest`;
exports.TASKS_ID = `${exports.SERVICE_NAME}-tasks`;
var CONSTANTS;
(function (CONSTANTS) {
    CONSTANTS["USER_STATE_DISABLED"] = "Disabled";
    CONSTANTS["USER_STATE_INVITED"] = "Invited";
    CONSTANTS["USER_STATE_REGISTERED"] = "Registered";
    CONSTANTS["USER_STATE_UPLOADED"] = "Uploaded";
    CONSTANTS["ORIGIN_SOURCE_WEB"] = "web";
    CONSTANTS["ORIGIN_SOURCE_UPLOAD"] = "upload";
})(CONSTANTS || (exports.CONSTANTS = CONSTANTS = {}));
var SEARCH_INDICES;
(function (SEARCH_INDICES) {
    SEARCH_INDICES["USER"] = "user";
})(SEARCH_INDICES || (exports.SEARCH_INDICES = SEARCH_INDICES = {}));
var ERRORS;
(function (ERRORS) {
    ERRORS["ERROR_BAD_EMAIL"] = "Invalid Email Address";
    ERRORS["ERROR_NONUNIQUE_USER"] = "A duplicate email or lookup key exists.";
    ERRORS["ERROR_MISSING_FNAME"] = "First name is empty";
    ERRORS["ERROR_MISSING_LNAME"] = "Last name is empty";
    ERRORS["ERROR_MISSING_ROLE"] = "Missing job function";
    ERRORS["ERROR_MISSING_LOOKUPKEY"] = "Missing lookup key";
    ERRORS["ERROR_MISSING_CUSTOMERKEY"] = "Missing customer Key";
    ERRORS["ERROR_NOUSER_FOUND"] = "User could not be found and was marked for termination";
    ERRORS["ERROR_USER_MISMATCH"] = "Lookup keys do not match the associated user";
})(ERRORS || (exports.ERRORS = ERRORS = {}));
var COLLECTIONS;
(function (COLLECTIONS) {
    COLLECTIONS["COLLECTION_USERS"] = "users/";
    COLLECTIONS["COLLECTION_USER_TERMS"] = "/user_terms_accepted/";
})(COLLECTIONS || (exports.COLLECTIONS = COLLECTIONS = {}));
var EVENTS;
(function (EVENTS) {
    EVENTS["USER_REENABLED"] = "user-reenabled";
    EVENTS["USER_DISABLED"] = "user-disabled";
    EVENTS["USER_DELETED"] = "user-deleted";
    EVENTS["USER_ADDED"] = "user-added";
    EVENTS["USER_UPDATED"] = "user-updated";
    EVENTS["USER_FIRST_TOU_ACCEPTED"] = "user-first-tou-accepted";
    EVENTS["USER_DEIDENTIFIED"] = "user-deidentified";
})(EVENTS || (exports.EVENTS = EVENTS = {}));
var QUEUES;
(function (QUEUES) {
    QUEUES["USER_UNLINK_AUTH"] = "user-unlink-auth";
    QUEUES["USER_LINK_AUTH"] = "user-link-auth";
    QUEUES["USER_TOU_LOG_ACCEPTED"] = "user-tou-accepted";
    QUEUES["USER_ADDED"] = "user-added";
    QUEUES["USER_UPDATED"] = "user-updated";
    QUEUES["USER_DELETED"] = "user-deleted";
    QUEUES["USER_GROUP_DEACTIVATE"] = "user-group-deactivate";
    QUEUES["USER_GROUP_REACTIVATE"] = "user-group-reactivate";
    QUEUES["USER_DEACTIVATE"] = "user-deactivate";
    QUEUES["USER_REACTIVATE"] = "user-reactivate";
})(QUEUES || (exports.QUEUES = QUEUES = {}));
var ENDPOINTS;
(function (ENDPOINTS) {
    ENDPOINTS["USER_UNLINK_AUTH"] = "/tasks/user/unlink_auth";
    ENDPOINTS["USER_LINK_AUTH"] = "/tasks/user/link_auth";
    ENDPOINTS["USER_TOU_LOG_ACCEPTED"] = "/tasks/user/tou_log_accepted";
    ENDPOINTS["USER_ADDED"] = "/tasks/user/added";
    ENDPOINTS["USER_UPDATED"] = "/tasks/user/updated";
    ENDPOINTS["USER_DELETED"] = "/tasks/user/deleted";
    ENDPOINTS["USER_GROUP_DEACTIVATE"] = "/tasks/user/deactivate-group";
    ENDPOINTS["USER_GROUP_REACTIVATE"] = "/tasks/user/reactivate-group";
    ENDPOINTS["USER_DEACTIVATE"] = "/tasks/user/deactivate";
    ENDPOINTS["USER_REACTIVATE"] = "/tasks/user/reactivate";
    ENDPOINTS["USER_SCHEDULE_DEIDENTIFY"] = "/tasks/user/schedule-deidentify";
    ENDPOINTS["USER_DEIDENTIFY"] = "/tasks/user/deidentify";
})(ENDPOINTS || (exports.ENDPOINTS = ENDPOINTS = {}));
var Permissions;
(function (Permissions) {
    Permissions["SearchAllUsers"] = "user/search-all-users";
    Permissions["PlatformAdminEditAllUsers"] = "user/platform-admin-edit-all-users";
    Permissions["PlatformAdminViewAllUsers"] = "user/platform-admin-view-all-users";
    Permissions["PlatformAdminSearchAllUsers"] = "user/platform-admin-search-all-users";
    Permissions["ManageAllCustomerUsers"] = "user/manage-all-customer-users";
    Permissions["ManageEmployees"] = "user/manage-employees";
})(Permissions || (exports.Permissions = Permissions = {}));
exports.ERROR_TYPES = Object.freeze({
    NOT_AUTHORIZED: `${exports.SERVICE_NAME}/not_authorized`,
    NOT_FOUND: `${exports.SERVICE_NAME}/user_not_found`,
    KEY_MISMATCH: `${exports.SERVICE_NAME}/customer_key_mismatch`,
    ALREADY_DISABLED: `${exports.SERVICE_NAME}/user_already_disabled`,
});
